import MacbookProAbout from '../assets/Macbookpro-about.png';
import icon1 from '../assets/icons/Icon-1.png';
import icon2 from '../assets/icons/Icon-2.png';
import icon0 from '../assets/icons/Icon.png';
import icon3 from '../assets/icons/dataflow-01.png';
import FaqMinusCircle from '../assets/icons/minus-circle.svg';
import FaqPlusCircle from '../assets/icons/plus-circle.svg';
import KeyFeatureMockupfour from '../assets/keyfeature-mockupfour.png';
import KeyFeatureMockupone from '../assets/keyfeature-mockupone.png';
import KeyFeatureMockupthree from '../assets/keyfeature-mockupthree.png';
import KeyFeatureMockuptwo from '../assets/keyfeature-mockuptwo.png';
import PlayIcon from '../assets/play-circle.svg';

export const ABOUT_IMAGES_REPO = {
  FaqMinusCircle,
  FaqPlusCircle,
  KeyFeatureMockupfour,
  KeyFeatureMockupone,
  KeyFeatureMockupthree,
  KeyFeatureMockuptwo,
  MacbookProAbout,
  PlayIcon,
  avatar01: '/images/about/geo-shape-13.svg',
  icon0,
  icon1,
  icon2,
  icon3,
  img01: '/images/about/Group-1.png',
  img02: '/images/about/image-dummy.svg',
  img10: '/images/about/check-about.svg',
};
